import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Users, Briefcase, Mail, ScrollText, LogOut, DollarSign } from "lucide-react";

const navItems = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard", end: true },
  { to: "/travelers", label: "Travelers", icon: Users, testid: "nav-travelers" },
  { to: "/packages", label: "Packages", icon: Briefcase, testid: "nav-packages" },
  { to: "/schedules", label: "Email Scheduler", icon: Mail, testid: "nav-schedules" },
  { to: "/expenses", label: "Expenses", icon: DollarSign, testid: "nav-expenses" },
  { to: "/logs", label: "Email Logs", icon: ScrollText, testid: "nav-logs" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex bg-[#F4F7FB]">
      {/* Sidebar */}
      <aside className="w-64 border-r border-[#E2E8F0] bg-white flex flex-col" data-testid="sidebar">
        <div className="p-5 border-b border-[#E2E8F0] flex items-center gap-3">
          <img src="/travelhostic-mark.png" alt="Travelhostic" className="w-11 h-11 object-contain" />
          <div>
            <div className="font-display text-lg font-semibold text-[#0F172A] leading-tight">Travelhostic</div>
            <div className="text-[9px] tracking-widest uppercase text-[#64748B]">Mapped by us</div>
          </div>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={item.testid}
              className={({ isActive }) =>
                `nav-link flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-[#0F172A] ${isActive ? "active" : ""}`
              }
            >
              <item.icon size={18} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-[#E2E8F0]">
          <div className="flex items-center justify-between mb-3">
            <div>
              <div className="text-sm font-semibold text-[#0F172A]" data-testid="user-name">{user?.name || "Admin"}</div>
              <div className="text-xs text-[#64748B]" data-testid="user-email">{user?.email}</div>
            </div>
          </div>
          <button
            onClick={handleLogout}
            data-testid="logout-btn"
            className="w-full flex items-center justify-center gap-2 px-4 py-2 rounded-lg border border-[#E2E8F0] text-sm hover:bg-[#F4F7FB] transition"
          >
            <LogOut size={16} /> Logout
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-x-hidden">
        <div className="p-8 max-w-7xl">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
